import React from 'react';

interface AmazonFireProps {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}

const AmazonFire = ({ color, width, height, className }: AmazonFireProps) => (
  <svg
    viewBox="-6.2 0 34.2 34.2"
    width={width}
    height={height}
    className={className}
  >
    <path
      stroke={color || '#000000'}
      d="M19.4 0h-17C1.1 0 0 1.1 0 2.4v29.4c0 1.3 1.1 2.4 2.4 2.4h17c1.3 0 2.4-1.1 2.4-2.4V2.4c0-1.3-1.1-2.4-2.4-2.4zm.5 29h-18V4.1h18V29z"
    />
  </svg>
);

export default AmazonFire;
